import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton, Grid, Hidden, LinearProgress, Button } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useDispatch } from 'react-redux';
import { Notes, SubHeading } from '../investors/components';
import { Location } from 'history';
import {
  AdminStrategyDetailsType,
  DistributorListType,
  strategyFormType,
} from '../../redux-store/types/api-types';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';

import { addStrategy, getStrategyById, updateStrategy } from '../../redux-store/actions/strategies';
import { addStrategyValidation } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import {
  ACCOUNT_TYPE_OPTIONS,
  FeeDetailTypeMasters,
  InvestmentTypeMaster,
  STRATEGY_TYPE_OPTIONS,
  YesNoMaster,
  distributorMaster,
  feeDetailsBrokerageAndTax,
} from '../../utils/constant';
import MFCheckbox from '../../lib/formik/Checkbox';
import { showError } from '../../redux-store/actions/auth';
import { getDistributorsListForFilters } from '../../redux-store/actions';
import UseRadioGroup from '../../lib/formik/Radio';
import { ConfirmationDialog } from '../commonComponents';
import {
  checkApplicableForYes,
  checkDPMSFlow,
  checkNDPMFlow,
  getKey,
} from '../../utils/utilityFunctions';
import { Item, ItemDetails } from '../ApplicationDetails';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';
import { particulars } from '../../utils/feeDescription';

const strategyFeilds = {
  sno: 0,
  fee: '',
  exitLoad: '',
  applicableForType: '',
  applicableFlowType: '',
  investmentType: '',
  feeType: '',
  costs: feeDetailsBrokerageAndTax,
  performanceFee: '',
  isActive: true,
  operatingCost: '',
};
export const filterStrategyFeeDetails = (strategy: strategyFormType[]): strategyFormType[] => {
  const filteredStrategyFeeDetails = strategy?.filter(
    (_strategy: strategyFormType) => _strategy.isActive
  );

  return filteredStrategyFeeDetails;
};

const isApplicableTypeDirect = (val: string): boolean => {
  return distributorMaster[val] === distributorMaster.Direct;
};
const isApplicableTypeDistributor = (val: string): boolean => {
  return distributorMaster[val] === distributorMaster.Distributor;
};
const isApplicableTypeRia = (val: string): boolean => {
  return distributorMaster[val] === distributorMaster.RIA;
};
export const checkHybridFee = (val: string): boolean => {
  return FeeDetailTypeMasters[val] === FeeDetailTypeMasters.Hybrid;
};

export const checkStratagyFeeDetails = (
  isApplicableForDirectVal: boolean | null,
  isApplicableForDistributorVal: boolean | null,
  isApplicableForRia: boolean | null,
  isDPMSFlowVal: boolean | null,
  isNDPMSFlowVal: boolean | null
): boolean => {
  return !!(
    (isApplicableForDirectVal || isApplicableForDistributorVal || isApplicableForRia) &&
    (isDPMSFlowVal || isNDPMSFlowVal)
  );
};

const initialValues: AdminStrategyDetailsType = {
  strategyName: '',
  strategyType: '',
  benchmark: '',
  investmentHorizon: '',
  isActive: true,
  distributorDetails: {
    distributorIds: [],
    distributors: [],
  },
  distributorIds: null,
  isApplicableForDirect: false,
  isApplicableForDistributor: false,
  isApplicableForRia: false,
  strategyFeeDetails: [],
  isNDPMSFlow: false,
  isDPMSFlow: false,
};

export default function AddStrategy({
  location,
}: {
  location: Location<{ StrategyId: string }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [strategyInitial, setStrategyInitial] = useState(initialValues);
  const { StrategyId } = location.state || {};
  const [distributorList, setDistributorList] = useState<DistributorListType[]>([]);
  const [stratagyFeeToDelete, setStratagyFeeToDelete] = useState<number | null>(null);
  const [distributorMasterData, setDistributorMasterData] = useState(distributorMaster);
  const accountTypeMaster = getKey(ACCOUNT_TYPE_OPTIONS);
  const provideTypeMaster = getKey(distributorMaster);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const res = (await dispatch(
          getDistributorsListForFilters({ isActive: true })
        )) as unknown as DistributorListType[];
        setDistributorList(
          res?.map((distribut) => {
            return {
              ...distribut,
              isRia: Object.keys(YesNoMaster)?.includes(distribut?.isRia) ? distribut?.isRia : 'no',
            };
          })
        );
        if (StrategyId) {
          const GetStrategyDetail = (await dispatch(
            getStrategyById(StrategyId)
          )) as unknown as AdminStrategyDetailsType;
          const {
            strategyName,
            strategyType,
            benchmark,
            investmentHorizon,
            strategyFeeDetails,
            isApplicableForDirect,
            isApplicableForDistributor,
            isApplicableForRia,
            distributorDetails,
            isDPMSFlow,
            isNDPMSFlow,
          } = GetStrategyDetail || {};

          setStrategyInitial({
            ...strategyInitial,
            strategyName,
            strategyType,
            benchmark,
            investmentHorizon,
            isDPMSFlow,
            isNDPMSFlow,
            isApplicableForDirect,
            isApplicableForDistributor,
            isApplicableForRia,
            distributorDetails,
            distributorIds:
              distributorDetails && distributorDetails.distributorIds?.length <= 0
                ? null
                : distributorDetails?.distributorIds || null,
            strategyFeeDetails:
              strategyFeeDetails?.length > 0
                ? strategyFeeDetails?.map((strategy, index) => {
                    return {
                      ...strategy,
                      sno: index,
                      costs: feeDetailsBrokerageAndTax,
                      taxes: feeDetailsBrokerageAndTax,
                    };
                  })
                : [],
          });
        } else {
          setStrategyInitial({
            ...strategyInitial,
          });
        }

        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);
  const filterDistributorList = (
    isApplicableForRia: boolean,
    isApplicableForDistributor: boolean,
    distributorList: DistributorListType[]
  ): DistributorListType[] => {
    return distributorList?.filter((val) => {
      if (isApplicableForRia && !isApplicableForDistributor) {
        return checkApplicableForYes(val?.isRia);
      } else if (!isApplicableForRia && isApplicableForDistributor) {
        return !checkApplicableForYes(val?.isRia);
      } else {
        return val;
      }
    });
  };
  const findCommonNumbers = (arr1: number[], arr2: number[]): number[] => {
    const set1 = new Set(arr1);
    return arr2.filter((number) => set1.has(number));
  };
  const handleFormMasterData = (
    isApplicableForDirect: boolean,
    isApplicableForDistributor: boolean,
    isApplicableForRia: boolean
  ) => {
    const formObject: { [key: string]: string } = {};
    if (isApplicableForDirect) {
      formObject.Direct = distributorMaster.Direct;
    }

    if (isApplicableForDistributor) {
      formObject.Distributor = distributorMaster.Distributor;
    }

    if (isApplicableForRia) {
      formObject.RIA = distributorMaster.RIA;
    }
    setDistributorMasterData(formObject);
  };
  const onSubmit = async (values: AdminStrategyDetailsType) => {
    try {
      if (
        !values.isApplicableForDirect &&
        !values.isApplicableForDistributor &&
        !values.isApplicableForRia
      ) {
        throw 'Please select Direct, Distributor, or RIA';
      }
      if (!values.isDPMSFlow && !values.isNDPMSFlow) {
        throw 'Please select Discretionary or Non-discretionary';
      }
      const riaDistributorIds: number[] = [];
      const distributorsIds: number[] = [];

      distributorList?.forEach((distributor) => {
        if (distributor) {
          if (distributor.id && checkApplicableForYes(distributor.isRia)) {
            riaDistributorIds.push(distributor.id);
          } else {
            if (distributor.id) {
              distributorsIds.push(distributor.id);
            }
          }
        }
      });

      if (
        values?.isApplicableForDistributor &&
        findCommonNumbers(distributorsIds, (values?.distributorIds || []) as number[])?.length <= 0
      ) {
        throw 'Please select distributors';
      }
      if (
        values?.isApplicableForRia &&
        findCommonNumbers(riaDistributorIds, (values?.distributorIds || []) as number[])?.length <=
          0
      ) {
        throw "Please select RIA's";
      }
      if (filterStrategyFeeDetails(values.strategyFeeDetails)?.length <= 0) {
        throw 'Please add at least one fee detail.';
      }
      if (
        (values.isApplicableForDirect &&
          !filterStrategyFeeDetails(values.strategyFeeDetails)?.some((val) =>
            isApplicableTypeDirect(val.applicableForType)
          )) ||
        (values.isApplicableForDistributor &&
          !filterStrategyFeeDetails(values.strategyFeeDetails)?.some((val) =>
            isApplicableTypeDistributor(val.applicableForType)
          )) ||
        (values.isApplicableForRia &&
          !filterStrategyFeeDetails(values.strategyFeeDetails)?.some((val) =>
            isApplicableTypeRia(val.applicableForType)
          ))
      ) {
        throw 'Please add at least one fee detail with a type distribution, direct, and RIA';
      }
      if (
        (values.isDPMSFlow &&
          !filterStrategyFeeDetails(values.strategyFeeDetails)?.some((val) =>
            checkDPMSFlow(val.applicableFlowType || '')
          )) ||
        (values.isNDPMSFlow &&
          !filterStrategyFeeDetails(values.strategyFeeDetails)?.some((val) =>
            checkNDPMFlow(val.applicableFlowType || '')
          ))
      ) {
        throw 'Please add at least one fee detail with a type Discretionary and one with a type Non-discretionary.';
      }

      const updatedStrategyFeeDetails = values.strategyFeeDetails
        ?.filter((_feeDetail) => _feeDetail?.id || _feeDetail.isActive)
        ?.map((val) => {
          // eslint-disable-next-line
          const { sno, ...rest } = val;
          return rest;
        });
      // eslint-disable-next-line
      const { distributorDetails, ...rest } = values;

      const payloadObj = {
        ...rest,
        strategyFeeDetails: updatedStrategyFeeDetails,
        distributorIds:
          rest.isApplicableForDistributor || rest.isApplicableForRia ? rest.distributorIds : [],
      };

      if (!StrategyId) {
        await dispatch(addStrategy(payloadObj));
      } else {
        await dispatch(updateStrategy(StrategyId, payloadObj));
      }
      history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
        StrategyId: StrategyId,
      });
    } catch (e) {
      if (typeof e === 'string') {
        dispatch(showError(e));
      } else {
        console.error((e as Error).message);
      }
    }
  };

  return (
    <>
      <Formik
        initialValues={strategyInitial}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validate={(values: AdminStrategyDetailsType) => {
          try {
            validateYupSchema(
              values,
              addStrategyValidation(distributorList?.map((distributor) => Number(distributor.id))),
              true,
              values
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, values, setValues }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
                      StrategyId: StrategyId,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  Strategy Setup
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(StrategyId ? 'strategy-details' : 'strategy-list', {
                      // planId: StrategyId,
                      StrategyId: StrategyId,
                    })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {StrategyId ? 'Edit Strategy' : 'Add Strategy'}
              </Typography>
            </Box>

            {loading ? (
              <LinearProgress sx={{ mt: 2 }} />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                  <SubHeading
                    sx={{
                      color: 'common.blue',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                      ml: { xs: 3.5 },
                    }}>
                    {'Strategy Details'}
                  </SubHeading>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="strategyName"
                      label="Strategy Name *"
                      placeholder="Enter Strategy Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFSelectField
                      name={`strategyType`}
                      label="Strategy type *"
                      items={Object.keys(STRATEGY_TYPE_OPTIONS)?.map((item) => ({
                        key: STRATEGY_TYPE_OPTIONS[item],
                        value: item,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name={`benchmark`}
                      label="Benchmark *"
                      placeholder="Enter Benchmark"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name={`investmentHorizon`}
                      label="Investment Horizon *"
                      placeholder="Enter Investment Horizon"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ mt: 5 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                      <MFCheckbox
                        name={`isDPMSFlow`}
                        label="Discretionary"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          let updateValues = [];

                          updateValues = values?.strategyFeeDetails?.map(
                            (value: strategyFormType) => {
                              return {
                                ...value,
                                isActive:
                                  checkDPMSFlow(value.applicableFlowType || '') &&
                                  !event.target.checked
                                    ? event.target.checked
                                    : value.isActive,
                                applicableFlowType:
                                  !value.applicableFlowType && !event.target.checked
                                    ? accountTypeMaster.non_discretionary
                                    : value.applicableFlowType,
                              };
                            }
                          );

                          setValues({
                            ...values,
                            isDPMSFlow: event.target.checked,
                            strategyFeeDetails: updateValues,
                          });
                        }}
                      />
                      <MFCheckbox
                        name={`isNDPMSFlow`}
                        label="Non discretionary"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          let updateValues = [];

                          updateValues = values?.strategyFeeDetails?.map(
                            (value: strategyFormType) => {
                              return {
                                ...value,
                                isActive:
                                  checkNDPMFlow(value.applicableFlowType || '') &&
                                  !event.target.checked
                                    ? event.target.checked
                                    : value.isActive,
                                applicableFlowType:
                                  !value.applicableFlowType && !event.target.checked
                                    ? accountTypeMaster.discretionary
                                    : value.applicableFlowType,
                              };
                            }
                          );

                          setValues({
                            ...values,
                            isNDPMSFlow: event.target.checked,
                            strategyFeeDetails: updateValues,
                          });
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} sx={{ mt: 5 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                      <MFCheckbox
                        name={`isApplicableForDirect`}
                        label="Direct"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          const checked = event.target.checked;

                          const updateValues = values.strategyFeeDetails.map(
                            (value: strategyFormType) => {
                              let applicableForType = value.applicableForType;

                              if (checked) {
                                if (
                                  !values.isApplicableForRia &&
                                  !values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.Direct;
                                }
                              } else {
                                if (value.applicableForType) {
                                  applicableForType = value.applicableForType;
                                } else if (
                                  values.isApplicableForRia &&
                                  !values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.RIA;
                                } else if (
                                  !values.isApplicableForRia &&
                                  values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.Distributor;
                                } else if (
                                  values.isApplicableForRia &&
                                  values.isApplicableForDistributor
                                ) {
                                  applicableForType = value.applicableForType || '';
                                }
                              }

                              return {
                                ...value,
                                applicableForType,
                                isActive:
                                  isApplicableTypeDirect(value.applicableForType) && !checked
                                    ? checked
                                    : value.isActive,
                              };
                            }
                          );
                          handleFormMasterData(
                            checked,
                            values.isApplicableForDistributor as boolean,
                            values.isApplicableForRia as boolean
                          );

                          setValues({
                            ...values,
                            isApplicableForDirect: checked,
                            strategyFeeDetails: updateValues,
                          });
                        }}
                      />

                      <MFCheckbox
                        name={`isApplicableForDistributor`}
                        label="Distributor"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          const checked = event.target.checked;

                          const updateValues = values.strategyFeeDetails.map(
                            (value: strategyFormType) => {
                              let applicableForType = value.applicableForType;

                              if (checked) {
                                if (!values.isApplicableForRia && !values.isApplicableForDirect) {
                                  applicableForType = provideTypeMaster.Distributor;
                                }
                              } else {
                                if (value.applicableForType) {
                                  applicableForType = value.applicableForType;
                                } else if (
                                  values.isApplicableForRia &&
                                  !values.isApplicableForDirect
                                ) {
                                  applicableForType = provideTypeMaster.RIA;
                                } else if (
                                  !values.isApplicableForRia &&
                                  values.isApplicableForDirect
                                ) {
                                  applicableForType = provideTypeMaster.Direct;
                                } else if (
                                  values.isApplicableForRia &&
                                  values.isApplicableForDirect
                                ) {
                                  applicableForType = value.applicableForType || '';
                                }
                              }

                              return {
                                ...value,
                                applicableForType,
                                isActive:
                                  isApplicableTypeDistributor(value.applicableForType) && !checked
                                    ? checked
                                    : value.isActive,
                              };
                            }
                          );
                          handleFormMasterData(
                            values.isApplicableForDirect as boolean,
                            checked,
                            values.isApplicableForRia as boolean
                          );

                          setValues({
                            ...values,
                            isApplicableForDistributor: checked,
                            strategyFeeDetails: updateValues,
                            distributorIds: !checked
                              ? filterDistributorList(
                                  values.isApplicableForRia as boolean,
                                  checked as boolean,
                                  distributorList
                                )
                                  .filter((disIds) =>
                                    ((values?.distributorIds || []) as number[]).includes(disIds.id)
                                  )
                                  .map((disIds) => disIds.id)
                              : !values?.isApplicableForRia
                              ? []
                              : values.distributorIds,
                          });
                        }}
                      />
                      <MFCheckbox
                        name={`isApplicableForRia`}
                        label="RIA"
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                          const checked = event.target.checked;

                          const updateValues = values.strategyFeeDetails.map(
                            (value: strategyFormType) => {
                              let applicableForType = value.applicableForType;

                              if (checked) {
                                if (
                                  !values.isApplicableForDirect &&
                                  !values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.RIA;
                                }
                              } else {
                                if (value.applicableForType) {
                                  applicableForType = value.applicableForType;
                                } else if (
                                  values.isApplicableForDirect &&
                                  !values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.Direct;
                                } else if (
                                  !values.isApplicableForDirect &&
                                  values.isApplicableForDistributor
                                ) {
                                  applicableForType = provideTypeMaster.Distributor;
                                } else if (
                                  values.isApplicableForDirect &&
                                  values.isApplicableForDistributor
                                ) {
                                  applicableForType = value.applicableForType || '';
                                }
                              }

                              return {
                                ...value,
                                applicableForType,
                                isActive:
                                  isApplicableTypeRia(value.applicableForType) && !checked
                                    ? checked
                                    : value.isActive,
                              };
                            }
                          );

                          handleFormMasterData(
                            values.isApplicableForDirect as boolean,
                            values.isApplicableForDistributor as boolean,
                            checked
                          );

                          setValues({
                            ...values,
                            isApplicableForRia: checked,
                            strategyFeeDetails: updateValues,
                            distributorIds: !checked
                              ? filterDistributorList(
                                  checked as boolean,
                                  values.isApplicableForDistributor as boolean,
                                  distributorList
                                )
                                  .filter((disIds) =>
                                    ((values?.distributorIds || []) as number[]).includes(disIds.id)
                                  )
                                  .map((disIds) => disIds.id)
                              : !values?.isApplicableForDistributor
                              ? []
                              : values.distributorIds,
                          });
                        }}
                      />
                    </Box>
                  </Grid>{' '}
                  {(values.isApplicableForDistributor || values.isApplicableForRia) && (
                    <Grid item xs={12} sm={12} md={12}>
                      <MultipleSelect
                        name="distributorIds"
                        label="Applicable Distributor's/RIA's*"
                        items={filterDistributorList(
                          values.isApplicableForRia as boolean,
                          values.isApplicableForDistributor as boolean,
                          distributorList
                        )?.map((item) => ({
                          key: item.id,
                          value: `${item.arnCode || 'N/A'} - ${item.name} (${item.type} ${
                            checkApplicableForYes(item.isRia) ? 'RIA' : 'Distributor'
                          })`,
                        }))}
                        renderText="Selected Distributor's/RIA's"
                      />
                    </Grid>
                  )}
                </Grid>

                {checkStratagyFeeDetails(
                  values?.isApplicableForDirect,
                  values?.isApplicableForDistributor,
                  values?.isApplicableForRia,
                  values?.isDPMSFlow,
                  values?.isNDPMSFlow
                ) && (
                  <>
                    {filterStrategyFeeDetails(values?.strategyFeeDetails)?.length > 0 && (
                      <>
                        <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                          <SubHeading
                            sx={{
                              color: 'common.blue',
                              letterSpacing: 0.5 + 'px',
                              padding: { xs: '10px 10px', sm: '10px 30px' },
                              ml: { xs: 3.5 },
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}>
                            <Typography>{`Fee Details`}</Typography>
                          </SubHeading>
                        </Grid>
                        {values?.strategyFeeDetails &&
                          values?.strategyFeeDetails?.length > 0 &&
                          filterStrategyFeeDetails(values?.strategyFeeDetails || [])?.map(
                            (strategy, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <Box
                                    sx={{
                                      bgcolor: 'white',
                                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.10)',
                                      borderRadius: '10px',
                                      py: { xs: 2, sm: 5 },
                                      pl: { xs: 0, sm: 5 },
                                      mt: { xs: 2, sm: 5 },
                                    }}>
                                    <Grid container rowSpacing={1} columnSpacing={4} px={4}>
                                      <Grid
                                        display={'flex'}
                                        alignItems={'center'}
                                        justifyContent={'flex-end'}
                                        item
                                        xs={12}
                                        sm={12}
                                        md={12}>
                                        <IconButton
                                          disabled={
                                            filterStrategyFeeDetails(values?.strategyFeeDetails)
                                              ?.length === 1
                                          }
                                          onClick={() => {
                                            setStratagyFeeToDelete(strategy.sno as number);
                                          }}>
                                          <DeleteOutlineIcon
                                            titleAccess="Delete Form"
                                            sx={{ cursor: 'pointer' }}
                                            color={
                                              filterStrategyFeeDetails(values?.strategyFeeDetails)
                                                ?.length === 1
                                                ? 'disabled'
                                                : 'error'
                                            }
                                            fontSize="small"
                                          />
                                        </IconButton>
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFSelectField
                                          name={`strategyFeeDetails.${strategy.sno}.investmentType`}
                                          label="Investment Type *"
                                          items={Object.keys(InvestmentTypeMaster)?.map((item) => ({
                                            key: InvestmentTypeMaster[item],
                                            value: item,
                                          }))}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFSelectField
                                          name={`strategyFeeDetails.${strategy.sno}.applicableFlowType`}
                                          label="Account Type *"
                                          items={Object.keys(ACCOUNT_TYPE_OPTIONS)?.map((item) => ({
                                            key: ACCOUNT_TYPE_OPTIONS[item],
                                            value: item,
                                          }))}
                                          disabled={!(values.isDPMSFlow === values.isNDPMSFlow)}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFSelectField
                                          name={`strategyFeeDetails.${strategy.sno}.feeType`}
                                          label="Fee Type *"
                                          items={Object.keys(FeeDetailTypeMasters)?.map((item) => ({
                                            key: FeeDetailTypeMasters[item],
                                            value: item,
                                          }))}
                                          disabled={!!strategy.id && !!strategy.feeType}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFSelectField
                                          name={`strategyFeeDetails.${strategy.sno}.applicableForType`}
                                          label="Provide Type *"
                                          items={Object.keys(distributorMasterData)?.map(
                                            (applicableForType) => ({
                                              key: distributorMasterData[applicableForType],
                                              value: applicableForType,
                                            })
                                          )}
                                          disabled={
                                            [
                                              values.isApplicableForDirect,
                                              values.isApplicableForDistributor,
                                              values.isApplicableForRia,
                                            ].filter((value) => value).length === 1
                                          }
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFTextField
                                          name={`strategyFeeDetails.${strategy.sno}.fee`}
                                          label="Management Fees *"
                                          placeholder="Enter Management Fees"
                                          disabled={!strategy.feeType}
                                        />
                                      </Grid>
                                      {checkHybridFee(strategy?.feeType) && (
                                        <Grid item xs={12} sm={6} md={4}>
                                          <MFTextField
                                            name={`strategyFeeDetails.${strategy.sno}.performanceFee`}
                                            label="Performance Fees *"
                                            placeholder="Enter Performance Fees"
                                            disabled={!strategy.feeType}
                                          />
                                        </Grid>
                                      )}

                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFTextField
                                          name={`strategyFeeDetails.${strategy.sno}.operatingCost`}
                                          label="Operating expenses other than brokerage *"
                                          placeholder="Enter operating expenses other than brokerage"
                                          disabled={!strategy.feeType}
                                        />
                                        {strategy.feeType && (
                                          <Notes
                                            displayContent={
                                              particulars[strategy.feeType]?.operatingCost
                                                ?.description
                                            }
                                          />
                                        )}
                                      </Grid>

                                      <Grid item xs={12} sm={6} md={4}>
                                        <MFTextField
                                          name={`strategyFeeDetails.${strategy.sno}.exitLoad`}
                                          label="Exit Load *"
                                          placeholder="Enter Exit Load"
                                          disabled={!strategy.feeType}
                                        />
                                      </Grid>
                                      <Grid item xs={12} sm={6} md={4}>
                                        <Box width={'100%'}>
                                          <Item>Brokerage expenses</Item>
                                          <ItemDetails sx={{ marginTop: '0.5rem' }}>
                                            {feeDetailsBrokerageAndTax || ''}
                                          </ItemDetails>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </React.Fragment>
                              );
                            }
                          )}
                      </>
                    )}

                    <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                      <Grid
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'flex-end'}
                        item
                        xs={12}
                        sm={12}
                        md={12}>
                        <Button
                          variant="outlined"
                          startIcon={<AddIcon />}
                          sx={{
                            color: 'primary.main',
                            fontWeight: 500,
                            fontSize: 14,
                            mr: { xs: 0, sm: 5 },
                            mt: { xs: 0.5, sm: 1 },
                          }}
                          onClick={() => {
                            const countTrueValues = [
                              values?.isApplicableForDirect,
                              values?.isApplicableForDistributor,
                              values?.isApplicableForRia,
                            ].filter(Boolean)?.length;
                            const newStrategyForm = {
                              ...strategyFeilds,
                              sno: values.strategyFeeDetails?.length,
                              applicableForType:
                                countTrueValues >= 2
                                  ? ''
                                  : values.isApplicableForDirect
                                  ? provideTypeMaster.Direct
                                  : values.isApplicableForDistributor
                                  ? provideTypeMaster.Distributor
                                  : values.isApplicableForRia
                                  ? provideTypeMaster.RIA
                                  : '',
                              applicableFlowType:
                                values.isDPMSFlow === values.isNDPMSFlow
                                  ? ''
                                  : values.isDPMSFlow
                                  ? accountTypeMaster.discretionary
                                  : values.isNDPMSFlow
                                  ? accountTypeMaster.non_discretionary
                                  : '',
                            };

                            setValues((val) => {
                              return {
                                ...val,
                                strategyFeeDetails: [...val.strategyFeeDetails, newStrategyForm],
                              };
                            });
                          }}>
                          Add Fee Details
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                )}

                <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                  <MFSubmitButton label="Save" />
                </Box>
              </>
            )}
            <ConfirmationDialog
              message={`Are you sure you want to delete the fee details ?`}
              open={stratagyFeeToDelete !== null}
              setOpen={() => setStratagyFeeToDelete(null)}
              onSave={() => {
                setValues({
                  ...values,
                  strategyFeeDetails: values.strategyFeeDetails?.map((formData) => {
                    return formData.sno === stratagyFeeToDelete
                      ? { ...formData, isActive: false }
                      : formData;
                  }),
                });
                setStratagyFeeToDelete(null);
              }}
              onCancel={() => setStratagyFeeToDelete(null)}
            />
          </Box>
        )}
      </Formik>
    </>
  );
}
